export const NUM_TOP_LEVEL_CATEGORIES = 4;
export var InputSize;
(function (InputSize) {
    InputSize[InputSize["Md"] = 0] = "Md";
    InputSize[InputSize["Lg"] = 1] = "Lg";
})(InputSize || (InputSize = {}));
export var Layout;
(function (Layout) {
    Layout[Layout["MOBILE"] = 0] = "MOBILE";
    Layout[Layout["DESKTOP"] = 1] = "DESKTOP";
})(Layout || (Layout = {}));
export const STANDARD_GRID_COLUMNS = {
    base: 1,
    sm: 2,
    md: 3,
    lg: 4,
};
export const STANDARD_GRID_GAP = 5;
export const GRID_CONTENT_MAX_WIDTH = 1600;
export const LISTING_GRID_PAGE_SIZE = 20;
export const FORM_FIELD_GAP = 5;
export const LISTING_CONTENT_MAX_WIDTH = 1200;
export const LISTING_PAGE_PADDING = 5;
export const LISTING_COLUMN_GAP_MOBILE = 5;
export const LISTING_COLUMN_GAP_DESKTOP = 10;
export const LISTING_PURCHASE_COLUMN_WIDTH = 375;
export const LISTING_VARIATION_GAP = 3;
export const GRID_PAGE_PADDING_Y = 5;
export const SECTION_TITLE_GAP = 2;
export const STANDARD_IMAGE_ASPECT_RATIO = 3 / 2;
export const LISTING_IMAGE_ASPECT_RATIO = 1;
export const LISTING_CARD_BODY_HEIGHT = 150;
export const LISTING_CARD_SHOP_TITLE_HEIGHT = 25;
export const SHOP_CARD_BODY_HEIGHT = 110;
export const ORDER_ITEM_CARD_BODY_HEIGHT = 155;
export const MAX_IMAGE_SIZE_MB = 5;
export const STANDARD_THUMBNAIL_WIDTH = 225;
export const STANDARD_THUMBNAIL_GAP = 3;
export const CLIENT_ROUTES = {
    admin: 'admin',
    category: 'category',
    shop: 'shop',
    listing: 'listing',
    favorites: 'favorites',
    checkout: 'checkout',
    order: 'order',
    orders: 'orders',
    shops: 'shops',
    analytics: 'analytics',
    manage: 'manage',
    info: 'info',
    listings: 'listings',
    messages: 'messages',
    new: 'new',
    settings: 'settings',
};
export var StorageKey;
(function (StorageKey) {
    StorageKey["SHOPPING_CART"] = "shopping-cart-v2";
    StorageKey["PENDING_FAVORITE"] = "pendingListingFavorite";
})(StorageKey || (StorageKey = {}));
export var CountryCode;
(function (CountryCode) {
    CountryCode["US"] = "US";
    CountryCode["CA"] = "CA";
    CountryCode["UK"] = "UK";
    CountryCode["IT"] = "IT";
    CountryCode["FR"] = "FR";
    CountryCode["DE"] = "DE";
    CountryCode["BE"] = "BE";
    CountryCode["CZ"] = "CZ";
    CountryCode["AT"] = "AT";
    CountryCode["CH"] = "CH";
    CountryCode["PT"] = "PT";
    CountryCode["DK"] = "DK";
    CountryCode["IS"] = "IS";
    CountryCode["NO"] = "NO";
    CountryCode["JP"] = "JP";
    CountryCode["NL"] = "NL";
})(CountryCode || (CountryCode = {}));
export const countryDisplayName = {
    [CountryCode.US]: 'USA',
    [CountryCode.CA]: 'Canada',
    [CountryCode.UK]: 'United Kingdom',
    [CountryCode.IT]: 'Italy',
    [CountryCode.FR]: 'France',
    [CountryCode.DE]: 'Germany',
    [CountryCode.BE]: 'Belgium',
    [CountryCode.CZ]: 'Czech Republic',
    [CountryCode.AT]: 'Austria',
    [CountryCode.CH]: 'Switzerland',
    [CountryCode.PT]: 'Portugal',
    [CountryCode.DK]: 'Denmark',
    [CountryCode.IS]: 'Iceland',
    [CountryCode.NO]: 'Norway',
    [CountryCode.JP]: 'Japan',
    [CountryCode.NL]: 'Netherlands',
};
export var FulfillmentType;
(function (FulfillmentType) {
    FulfillmentType["DIRECT"] = "DIRECT";
    FulfillmentType["HEIRLOOM"] = "HEIRLOOM";
})(FulfillmentType || (FulfillmentType = {}));
export const STANDARD_RETURN_POLICY_HTML = '<ul><li>A free return label will be sent to the customer via email upon initiation of a return.</li><li>A refund will be issued to the original payment method within 7 days of receipt of the returned items.</li><li>Returned items must be in their original condition and packaging.</li></ul>';
export var InfoPageKey;
(function (InfoPageKey) {
    InfoPageKey["ABOUT"] = "ABOUT";
    InfoPageKey["SHIPPING_RETURNS"] = "SHIPPING_RETURNS";
    InfoPageKey["PRIVACY"] = "PRIVACY";
    InfoPageKey["TERMS_OF_SERVICE"] = "TERMS_OF_SERVICE";
})(InfoPageKey || (InfoPageKey = {}));
